module.exports = __webpack_public_path__ + "static/img/frack1.a7fdacab.png";